import { queryOptions } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import queryClient from '#/api/queryClient';
import type { RequestOpts } from '../api-types';

const method = api.getLoansDebtinfos;
export type UseLoanDebtInfoResponse = Awaited<ReturnType<typeof method>>;

function getLoanDebtInfoQuery(opts: RequestOpts = {}) {
  const queryKey = ['getLoanDebtInfo'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return method({
        ...opts,
        signal,
      }) as unknown as Promise<api.AllRemainingDebtInfos>;
    },
    retry: 3,
    retryDelay: ms('1s'),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchLoanDebtInfo(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getLoanDebtInfoQuery(opts));
}
